// extracted by mini-css-extract-plugin
module.exports = {"container":"pageHeader_container__2XPT1","title":"pageHeader_title__2FWdW","secondary":"pageHeader_secondary__BUohO"};